import React from "react";
import IconBase from "./IconBase";
import icon from "./back.svg";

export default function IconBack({ width, height }) {
  return <IconBase alt="zurueck" img={icon} width={width} height={height} />;
}
